module.exports = __webpack_public_path__ + "img/onboarding_5.afc0dfbb.png";